import React from 'react'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  statusChip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: 9999,
    padding: '2px 8px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    whiteSpace: 'nowrap',
  },
  paid: {
    backgroundColor: '#E0EAFF',
    color: '#001C57',
  },
  unpaid: {
    backgroundColor: '#EBF0F2',
    color: '#172024',
  },
  statusCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
  },
}))

export const PaymentStatusChip = ({ isPaid }) => {
  const classes = useStyles()

  return (
    <Box
      component="span"
      className={`${classes.statusChip} ${
        isPaid ? classes.paid : classes.unpaid
      }`}
    >
      {isPaid ? 'Paid' : 'Not Paid'}
    </Box>
  )
}

export const usePaymentStatusStyles = useStyles
